import { FC, useState } from 'external/react'
import {
  styled,
  Typography,
  CancelIcon,
  IconButton,
  AccordionSummary,
  AccordionDetails,
  accordionSummaryClasses,
  ArrowForwardIosSharpIcon,
  Accordion,
 } from 'external/material'

type BaseAccordionProps = {
  title: string
  className?: string
}

type AccordionProps = BaseAccordionProps & (
  | { deleteButton: true, handleDelete: () => void }
  | { deleteButton: false, handleDelete?: undefined }
)

const StyledPlannificationAccordion = styled(Accordion)(plannificationAccordionStyles)

const PlanificationAccordion: FC<AccordionProps> = ({ className, children, title, deleteButton, handleDelete }) => {
  const [expanded, setExpanded] = useState<boolean>(true)
  return (
    <StyledPlannificationAccordion className={className} expanded={expanded} onChange={() => setExpanded((prev) => !prev)} sx={{}} disableGutters={true} elevation={0}>
      <AccordionSummary className='accordion-summary' expandIcon={<ArrowForwardIosSharpIcon className="icon" />} >
        <div className='title'>
          {deleteButton && <div className='delete'> <IconButton onClick={(e) => { e.stopPropagation(); handleDelete(); }}> <CancelIcon fontSize={'small'}/></IconButton></div>}
          <Typography component='span'>{title}</Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className="accordion-details">
        {children}
      </AccordionDetails>
    </StyledPlannificationAccordion>
  )
}

export {PlanificationAccordion as default}

function plannificationAccordionStyles () {
  return {
    backgroundColor: '#fff',
    '&::before': {
      display: 'none'
    },
    "& .accordion-summary": {
      flexDirection: 'row-reverse',
      padding: 0,
      gap: '16px',
      backgroundColor: 'rgba(0,0,0, 0.02)',
      color: 'rgba(0,0,30,1)', 
      '& .MuiSvgIcon-root': {
        fontSize: 20,
        transition: 'transform 200ms linear 0s',
      },
      [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
      {
        transform: 'none',
        'svg': {
          transform: 'rotate(90deg)',
        }
      },
      [`& .${accordionSummaryClasses.expandIconWrapper}`]:
      {
        backgroundColor: 'rgba(165, 211, 243, 0.5)',
        minHeight: '48px',
        width: '48px',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      },
      "& .title": {
         display: 'flex',
         alignItems: 'center',
         gap: '8px',
         justifyContent: 'space-between',
         width: '100%',
         "& .delete": {
              position: 'absolute',
              right: 0,
              padding: '8px 5px',
              cursor: 'pointer'
         },
         "& span": {
           fontWeight: 'bold'
        
         }
        
      },
    },
    "& .accordion-details": {
      padding: 24
    }
  }
}